<div class="infolog-panel" *ngIf="infolog.messages().length > 0">
    <div class="infolog-header">
        <span class="infolog-title">Infolog</span>
        <button class="clear-btn" [disabled]="infolog.messages().length === 0" (click)="infolog.clearAll()">
            X Clear Log
        </button>
    </div>

    <div class="infolog-body" #logBody>
        <div class="infolog-empty" *ngIf="infolog.messages().length === 0">No log entries.</div>
        <div *ngFor="let msg of infolog.messages()">
            <div class="infolog-entry" [ngClass]="msg.type">
                <span class="entry-message">{{ msg.message }}</span>
                <button class="dismiss-btn" (click)="infolog.remove(msg.id)" title="Dismiss">✕</button>
            </div>
        </div>

    </div>
</div>